import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TooltipComponent } from "./tooltip.component";
import { TooltipDirective } from "./tooltip.directive";
import { TooltipButtonComponent } from "./tooltip-button/tooltip-button.component";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ TooltipComponent, TooltipButtonComponent, TooltipDirective ],
  imports: [ CommonModule, TranslateModule, OverlayModule, MatIconModule ],
  exports: [ TooltipDirective, TooltipButtonComponent ],
})
export class TooltipModule {}
